import GlobalInterfaceStyle from "../UI/GlobalInterfaceStyle";
import React, { useState } from "react";
import { SContainer, SLayout, SMain } from "./styles";
import Sidebar from "../Sidebar/Sidebar";
import TopDetail from "../TopDetail";

function Layout({children, onLogout}){
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleSidebarOnChange = (sidebarOpen) =>{
        setSidebarOpen(sidebarOpen)
    }

    return (
        <>
            <GlobalInterfaceStyle />
            <SLayout>
                <Sidebar sidebarOnChange={handleSidebarOnChange} onLogout={onLogout}/>
                <SMain data-isopen={sidebarOpen}>
                    <TopDetail onLogout={onLogout}/>
                    <SContainer data-isopen={sidebarOpen}>{children}</SContainer>
                </SMain>
            </SLayout>
        </>
    );
}

export default Layout;